import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from 'state/store';

export function useGetActiveStepIndex() {
  const { form } = useSelector((state: RootState) => state.application);
  const { pages } = form;

  const { isLeadProfile } = useSelector(
    (state: RootState) => state.auth ?? { isLeadProfile: false },
  );

  const { currentTabIndex, activeStepByTab } = useSelector((state: RootState) => state.navigation);

  const { pageId } = useParams() as {
    pageId: string;
  };

  const getActiveStepIndex = React.useCallback(() => {
    if (isLeadProfile) {
      // For lead profile, get activeStepId from Redux state
      const activeStepId = activeStepByTab[currentTabIndex] || '';
      return pages.findIndex((page) => page.id === activeStepId);
    }
    // For regular leasing journey, get pageId from URL params
    return pages.findIndex((page) => page.id === pageId);
  }, [pageId, pages, isLeadProfile, currentTabIndex, activeStepByTab]);

  return getActiveStepIndex;
}

export function useActiveStepIndexFromRedux() {
  const { currentTabIndex, activeStepByTab } = useSelector((state: RootState) => state.navigation);
  const activeStepId = activeStepByTab[currentTabIndex] || '';

  const { form } = useSelector((state: RootState) => state.application);
  const { pages } = form;

  const activeStepIndex = pages.findIndex((page) => page.id === activeStepId);

  return activeStepIndex;
}
